// HOOKS
import { useState } from "react";

const useSelected = (initialState = []) => {
  const [selected, setSelected] = useState(initialState);

  const resetSelected = () => {
    setSelected([]);
  };

  const removeSelected = (_id) => {
    setSelected([...selected?.filter((item) => item?._id !== _id)]);
  };

  const addSelected = (item) => {
    setSelected([...selected, item]);
  };

  return { selected, setSelected, resetSelected, removeSelected, addSelected };
};

export default useSelected;
